import { defineMessages } from "react-intl";

const messages = defineMessages({
  allDay: {
    id: "createActivityModal.footer.scheduleActivity.allDay",
    defaultMessage: "All Day",
    description: "All Day",
  },
  annually: {
    id: "createActivityModal.footer.scheduleActivity.repeat.annually",
    defaultMessage: "Annually on {date}",
    description: "Annually",
  },
  custom: {
    id: "createActivityModal.footer.scheduleActivity.repeat.custom",
    defaultMessage: "Custom...",
    description: "Custom",
  },
  daily: {
    id: "createActivityModal.footer.scheduleActivity.repeat.daily",
    defaultMessage: "Daily (Weekdays Only)",
    description: "Daily (Weekdays Only)",
  },
  dateFormatAnnually: {
    id: "createActivityModal.footer.scheduleActivity.repeat.dateFormatAnnually",
    defaultMessage: "MMMM, do",
    description: "Date format for annual recurrence (month and ordinal day)",
  },
  doesNotRepeat: {
    id: "createActivityModal.footer.scheduleActivity.repeat.doesNotRepeat",
    defaultMessage: "Does not repeat",
    description: "Does not repeat",
  },
  every: {
    id: "createActivityModal.footer.scheduleActivity.repeat.every",
    defaultMessage: "Every {number, plural, one {} other {{number} }}{units}",
    description: "Repeat every number of time units",
  },
  everyOn: {
    id: "createActivityModal.footer.scheduleActivity.repeat.everyOn",
    defaultMessage: "Every {number, plural, one {} other {{number} }}{units} on {on}",
    description: "Repeat every number of time units with on",
  },
  excludeWeekends: {
    id: "createActivityModal.footer.scheduleActivity.repeat.excludeWeekends",
    defaultMessage: "Exclude Weekends",
    description: "Exclude Weekends",
  },
  monthly: {
    id: "createActivityModal.footer.scheduleActivity.repeat.monthly",
    defaultMessage: "Monthly on {date}",
    description: "Monthly",
  },
  repeatEvery: {
    id: "createActivityModal.footer.scheduleActivity.repeat.repeatEvery",
    defaultMessage: "Repeat every",
    description: "Repeat every",
  },
  title: {
    id: "createActivityModal.footer.scheduleActivity.repeat.title",
    defaultMessage: "Custom Interval",
    description: "Custom Interval",
  },
  tooltip: {
    id: "createActivityModal.footer.scheduleActivity.repeat.tooltip",
    defaultMessage: "Repeat Activity Options",
    description: "Repeat Activity Options",
  },
  weekly: {
    id: "createActivityModal.footer.scheduleActivity.repeat.weekly",
    defaultMessage: "Weekly on {date}",
    description: "Weekly",
  },
});

export default messages;
